import { render } from "./DeleteGroupModal.vue?vue&type=template&id=f6635c28"
import script from "./DeleteGroupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteGroupModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/PlatformList/DeleteGroupModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6635c28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6635c28', __exports__)) {
    api.reload('f6635c28', __exports__)
  }
  
  module.hot.accept("./DeleteGroupModal.vue?vue&type=template&id=f6635c28", () => {
    api.rerender('f6635c28', render)
  })

}


export default __exports__